import React from 'react';

import GrowthTableRowImpact from './GrowthTableRowImpact';

export default function({row_data, growthMin}) {

    const render_row = row_data.map((impact_data, impact_key) => {
        return (
            <GrowthTableRowImpact
                key={impact_key}
                row_data={row_data}
                impact_data={impact_data}
                impact_key={impact_key}
                growthMin={growthMin}
            />
        );
    })

    return render_row;
}